interface PackDescriptionProps {
  description: string | null | undefined;
}

const PackDescription = ({ description }: PackDescriptionProps) => {
  if (!description) return null;

  return (
    <div className="mt-4 bg-[#F8F9FA] rounded-xl px-4 py-3">
      <div className="mb-1">
        <span className="text-gray-800 font-bold text-sm">📢 팩 설명</span>
      </div>
      <p className="text-gray-600 text-sm whitespace-pre-wrap leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default PackDescription;
